import { Tag } from "common/components/ui/Tag";

import useLeadListSources from "../../datahooks/useLeadListSources";
import LeadListSourcesTag from "../LeadListSourcesTag";

interface LeadListSourceTypesProps {
  listId: string;
}

/**
 * The source types of one list - a list without any source isn't mining yet, so
 * it reads as a draft.
 */
export default function LeadListSourceTypes({
  listId,
}: LeadListSourceTypesProps) {
  const { leadListSources, isLoadingLeadListSources } = useLeadListSources({
    listId,
  });

  if (isLoadingLeadListSources) {
    return <LeadListSourcesTag sources={[]} isLoading />;
  }

  const sources = leadListSources ?? [];

  if (!sources.length) {
    return (
      <Tag variant="tertiary" className="w-fit" size="sm">
        Draft
      </Tag>
    );
  }

  return <LeadListSourcesTag sources={sources} />;
}
